( function( $ ) {
	//Load start
	$(window).load(function() {
		$(".seopress-load-icon").fadeOut("slow");
	});
	//Load start END
} )( jQuery );
